import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/public/orders`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  readByToken({commit}, payload: {token: object}) {
    return axiosInstance.get(baseUrl + "/token/" + payload.token, {})
    .then((data) => data.data);
  },
  updateByToken({commit}, payload: {order: any}) {
    return axiosInstance.put(baseUrl + "/token/" + payload.order.token, payload.order)
      .then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
